import React from 'react';
import PropTypes from 'prop-types';
import { FlightTicketPropType } from 'PropTypes';

import StatusStaffTabsRow from 'Components/StatusStaffTabsRow';
import AttachementsCard from 'Views/TicketProfile/Components/AttachementsCard';

const AttachementsTab = (props) => {
  const { flyToWorkTicketInfo, setRefreshComponent, refreshComponent } = props;

  return (
    <React.Fragment>
      <StatusStaffTabsRow flyToWorkTicketInfo={flyToWorkTicketInfo} />
      <hr style={{ marginTop: 0 }} />
      <AttachementsCard
        flyToWorkTicketInfo={flyToWorkTicketInfo}
        setRefreshComponent={setRefreshComponent}
        refreshComponent={refreshComponent}
      />
    </React.Fragment>
  );
};

AttachementsTab.propTypes = {
  flyToWorkTicketInfo: FlightTicketPropType.isRequired,
  setRefreshComponent: PropTypes.func,
  refreshComponent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default AttachementsTab;
